import { TripDetailsPerformance } from '../../../types/runningTimeAnalyticsTypes';
import { TableDispatchAction, TableSortProperties } from '../../../types/types';

export default function tableSortReducer(state: TableSortProperties<TripDetailsPerformance>, action: TableDispatchAction<TripDetailsPerformance>): TableSortProperties<TripDetailsPerformance> {
    switch (action.type) {
        case 'CHANGE_SORT': {
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }
            let data = [];
            switch (action.column) {
                case 'vehicleId':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as string;
                        const bVal = b[action.column] as string;
                        if (aVal > bVal) {
                            return 1;
                        } else if (aVal < bVal) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
                case 'serviceDate':
                case 'tripActualStart':
                case 'tripActualFinish':
                    data = state.data.sort((a: TripDetailsPerformance, b: TripDetailsPerformance) => new Date(a[action.column] as string).getTime() - new Date(b[action.column] as string).getTime());
                    break;
                case 'startDelaySec':
                case 'totalStopSec':
                case 'totalInMotionSec':
                case 'performance':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                default:
                    data = state.data;
            }
            return {
                column: action.column,
                data: data,
                direction: 'ascending',
            };
        }
        case 'UPDATE_DATA': {
            return {
                ...state,
                data: action.data || [],
            };
        }
    }
}